import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logger } from './lib/logger';
import { queryClient } from './lib/query-client';
import './i18n/config';
import './styles/globals.css';

// Catch async errors that don't bubble through React's error boundary
// (Promise rejections, setTimeout callbacks, etc.).
window.addEventListener('unhandledrejection', (event) => {
  logger.error('unhandled promise rejection', {
    reason: String(event.reason),
  });
});
window.addEventListener('error', (event) => {
  logger.error('uncaught error', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing in index.html');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
